// Tags to identify the loaAutomation flow and blueprint
// For reference TAG_LOAAUTOMATION_BLUEPRINT = 'b621f2bc-ce2c-49a0-92c7-b7043e4302b6';
export const TAG_LOAAUTOMATION_FLOW = '29fc3f3c-1fff-4818-8ec1-eb8e630adccf';
